// Feature flags for gradual rollout of new features
export const featureFlags = {
  // Enable optimistic updates for circuit/load creation
  // This makes the UI feel much faster by showing changes immediately
  OPTIMISTIC_CIRCUIT_CREATION: true,
  
  // You can disable this for specific users or conditions
  // For example: based on user preferences, device type, etc.
  isOptimisticCircuitCreationEnabled: (isMobile?: boolean) => {
    // Could add more complex logic here, e.g.:
    // - Check user preferences from localStorage
    // - Disable on certain browsers
    // - A/B testing logic
    // - etc.
    
    // For now, enable for all users
    return featureFlags.OPTIMISTIC_CIRCUIT_CREATION;
  }
};

// Helper to check if we're in development mode
export const isDevelopment = import.meta.env.DEV;

// Helper to get feature flag from URL params (useful for testing)
export function getFeatureFlagFromUrl(flagName: string): boolean | null {
  if (typeof window === 'undefined') return null;
  
  const params = new URLSearchParams(window.location.search);
  const value = params.get(`ff_${flagName}`);
  
  if (value === '1' || value === 'true') return true;
  if (value === '0' || value === 'false') return false;
  
  return null;
}